import React, { useEffect, useState } from "react";
import { IconButton, Typography, Card, CardContent } from "@mui/material";
import DeleteForeverIcon from "@mui/icons-material/DeleteForever";
import Lightbox from "react-awesome-lightbox";
import "react-awesome-lightbox/build/style.css";
import { useLanguageContext } from "../../../Context/LanguageContext";
import NotFoundCard from "../../ReusableComponent/NotFoundCard";

export default function InspectionImagePopOver({
  handleImagePopover,
  imageList,
  handleImageDel,
}) {
  const { localization } = useLanguageContext();
  const [imageSrc, setImageSrc] = useState(null);

  const [biggerImage, setBiggerImage] = useState({
    isShow: false,
    selectedIndex: null,
  });

  useEffect(() => {
    if (imageList) {
      let _tempImage = [];
      imageList.map((item) => _tempImage.push(item.Filecontent));
      setImageSrc(_tempImage);
    }
  }, [imageList]);

  function handleLightBox(e, _value) {
    e.preventDefault();
    setBiggerImage({
      isShow: true,
      selectedIndex: _value,
    });
  }

  return (
    <React.Fragment>
      <div
        className="modal in dialogBox"
        id="MsgModalCenter"
        tabIndex="-1"
        role="dialog"
        aria-labelledby="MsgModalCenterTitle"
        aria-hidden="true"
      >
        <div
          className="modal-dialog d-flex justify-content-center"
          role="document"
        >
          {imageSrc && (
            <div className="modal-content inspectionImageModel">
              <div className="modal-header">
                <h5 className="modal-title">{localization.selectedImage}</h5>
                <button
                  type="button"
                  className="close"
                  data-dismiss="modal"
                  aria-label="Close"
                  onClick={() => handleImagePopover(false)}
                >
                  <span aria-hidden="true">&times;</span>
                </button>
              </div>

              <div className="modal-body d-flex flex-column inspectionImageModelDiv">
                {imageSrc.length > 0 ? (
                  imageSrc.map((item, index) => (
                    <div
                      key={index}
                      className="image-container row ml-0 mr-0 inspectionImageDiv"
                    >
                      <div className="col">
                        <img
                          className="imageDiv cursorPoint mr-2 inspectionImageDivSrc"
                          alt="not Found"
                          src={item}
                          onClick={(e) => handleLightBox(e, index)}
                        />
                      </div>

                      <div className="col d-flex justify-content-end">
                        <IconButton onClick={(e) => handleImageDel(index)}>
                          <DeleteForeverIcon className="inspectionImageDivDelButton" />
                        </IconButton>
                      </div>
                    </div>
                  ))
                ) : (
                  <NotFoundCard title={localization.noImageAvailable} />
                )}
              </div>
              <div className="modal-footer"></div>
            </div>
          )}
        </div>
      </div>
      {biggerImage.isShow &&
        (imageSrc.length === 1 ? (
          <Lightbox
            allowReset={false}
            onClose={() => {
              setBiggerImage({
                isShow: false,
                selectedIndex: null,
              });
            }}
            image={imageSrc[0]}
          />
        ) : (
          <Lightbox
            allowReset={false}
            onClose={() => {
              setBiggerImage({
                isShow: false,
                selectedIndex: null,
              });
            }}
            images={imageSrc}
            startIndex={biggerImage.selectedIndex}
          />
        ))}
    </React.Fragment>
  );
}
